var _desc, _defs, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivisionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.15261373475096,
    height: 46.15261373475104,
    viewBox: "265.11630587242723 233.00992313265834 46.15261373475096 46.15261373475104",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6654003158 0 0 0.6654003158 288.1926127398 256.08623)",
    id: "bSJptUibtiq3zgHx4OPJk"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(39,236,227)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,234,234)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(0, 0)",
    d: "M 0 -34.68034 C 19.14355 -34.68034 34.68034 -19.14355 34.68034 0 C 34.68034 19.14355 19.14355 34.68034 0 34.68034 C -19.14355 34.68034 -34.68034 19.14355 -34.68034 0 C -34.68034 -19.14355 -19.14355 -34.68034 0 -34.68034 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 288.1926127398 256.08623)",
    id: "NQvGXSAcw1k7KsvUYDPwj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.225985 -6.25)",
    id: "vfy2nhhhY10ka4CHfjp0P",
    clipPath: "url(#CLIPPATH_30)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "clip0_714_6345",
    x: -15.0311,
    y: -15,
    rx: 0,
    ry: 0,
    width: 30.0622,
    height: 30
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-8.274015, -8.75)",
    d: "M 11.6564 12.9602 C 10.5728 11.8848 9.902 10.3956 9.902 8.75 C 9.902 7.10444 10.5728 5.61524 11.6564 4.53985 C 11.0325 4.23416 10.3308 4.0625 9.58885 4.0625 C 6.99465 4.0625 4.89163 6.16117 4.89163 8.75 C 4.89163 11.3388 6.99465 13.4375 9.58885 13.4375 C 10.3308 13.4375 11.0325 13.2658 11.6564 12.9602 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.3518 -6.25)",
    id: "BONLstooxJaYWcbCWCgf1",
    clipPath: "url(#CLIPPATH_31)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "clip0_714_6345",
    x: -15.0311,
    y: -15,
    rx: 0,
    ry: 0,
    width: 30.0622,
    height: 30
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-15.8518, -8.75)",
    d: "M 11.1546 8.75 C 11.1546 6.16117 13.2576 4.0625 15.8518 4.0625 C 18.446 4.0625 20.549 6.16117 20.549 8.75 C 20.549 11.3388 18.446 13.4375 15.8518 13.4375 C 13.2576 13.4375 11.1546 11.3388 11.1546 8.75 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 7.9296 -6.25)",
    id: "54dW9vVHVYQWYLEjuDpon",
    clipPath: "url(#CLIPPATH_32)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "clip0_714_6345",
    x: -15.0311,
    y: -15,
    rx: 0,
    ry: 0,
    width: 30.0622,
    height: 30
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-23.4296, -8.75)",
    d: "M 20.0472 4.53985 C 21.1308 5.61524 21.8016 7.10444 21.8016 8.75 C 21.8016 10.3956 21.1308 11.8848 20.0472 12.9602 C 20.6711 13.2658 21.3728 13.4375 22.1148 13.4375 C 24.709 13.4375 26.812 11.3388 26.812 8.75 C 26.812 6.16117 24.709 4.0625 22.1148 4.0625 C 21.3728 4.0625 20.6711 4.23416 20.0472 4.53985 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.351805 5)",
    id: "FA7UbfomJFssfuIBmgpJ9",
    clipPath: "url(#CLIPPATH_33)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "clip0_714_6345",
    x: -15.0311,
    y: -15,
    rx: 0,
    ry: 0,
    width: 30.0622,
    height: 30
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-15.851805, -20)",
    d: "M 7.39681 20 C 7.39681 17.4112 9.49983 15.3125 12.094 15.3125 L 19.6096 15.3125 C 22.2038 15.3125 24.3068 17.4112 24.3068 20 C 24.3068 22.5888 22.2038 24.6875 19.6096 24.6875 L 12.094 24.6875 C 9.49983 24.6875 7.39681 22.5888 7.39681 20 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.886075 3.75)",
    id: "vfOTlyxEiCgTAPWssbic5",
    clipPath: "url(#CLIPPATH_34)"
  }, _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "clip0_714_6345",
    x: -15.0311,
    y: -15,
    rx: 0,
    ry: 0,
    width: 30.0622,
    height: 30
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-6.613925, -18.75)",
    d: "M 1.13385 18.75 C 1.13385 16.1612 3.23687 14.0625 5.83107 14.0625 L 12.094 14.0625 C 8.80804 14.0625 6.14422 16.7208 6.14422 20 C 6.14422 21.2811 6.55079 22.4674 7.24218 23.4375 L 5.83107 23.4375 C 3.23687 23.4375 1.13385 21.3388 1.13385 18.75 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 9.5897 3.75)",
    id: "FXQCNYdR1yDEyfSWEb7Pr",
    clipPath: "url(#CLIPPATH_35)"
  }, _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "clip0_714_6345",
    x: -15.0311,
    y: -15,
    rx: 0,
    ry: 0,
    width: 30.0622,
    height: 30
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-25.0897, -18.75)",
    d: "M 25.5594 20 C 25.5594 21.2811 25.1528 22.4674 24.4614 23.4375 L 25.8726 23.4375 C 28.4668 23.4375 30.5698 21.3388 30.5698 18.75 C 30.5698 16.1612 28.4668 14.0625 25.8726 14.0625 L 19.6096 14.0625 C 22.8956 14.0625 25.5594 16.7208 25.5594 20 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivisionIcon);
export default __webpack_public_path__ + "static/media/division_icon.8aac50a4a21ca33046a2e194f80ab333.svg";
export { ForwardRef as ReactComponent };